import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgHyperEvm = function SvgHyperEvm(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 48 48"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 24,
        cy: 24,
        r: 24,
        fill: "#072723"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#97FCE4",
        d: "M41 23.343c0 11.15-6.879 14.728-10.503 11.542-2.984-2.598-3.871-8.087-8.358-8.65-5.696-.711-6.189 6.812-9.937 6.812C7.838 33.047 7 26.75 7 23.514c0-3.308.937-7.817 4.66-7.817 4.34 0 4.586 6.445 10.01 6.102 5.4-.368 5.498-7.082 9-9.95C33.726 9.375 41 12.047 41 23.344"
    })));
};

export { SvgHyperEvm as ReactComponent };
//# sourceMappingURL=HyperEVM.svg.es.js.map
